import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ModalService } from '../../../../services/modal.service';
import { showErrorMessage } from '../../../../utils/utils';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CampaignStatusPipe } from '../../../../pipes/campaignStatus.pipe';
import { Page } from '../../../../models/page.model';
import { AROrgeCampaign, AROrgeCampaignConfiguration } from '../../../../models/agrorendement-orge.model';
import { AROrgeService } from '../../../../services/agrorendement-orge.service';
import { AROrgeCampaignConfigurationEditComponent } from './campaign-config-edit.component';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-orge-campaigns-cmp',
  templateUrl: 'campaigns.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, AROrgeCampaignConfigurationEditComponent, CampaignYearPipe, CampaignStatusPipe, TranslatePipe, CommonModule, FormsModule, PaginationModule],
  providers: [AROrgeService],
})
export class AROrgeCampaignComponent implements OnInit, AfterViewInit {
  error: any;

  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public filter: string = '';

  constructor(
    private orgeService: AROrgeService,
    private modal: ModalService,
    private router: Router,
  ) {}

  getCampaignsPaginated(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: string) {
    this.orgeService
      .getPageCampaigns(pageIndex, this.itemsPerPage, sortColumnName, sortColumnOrder, filter)
      .subscribe((page) => this.handlePage(page));
  }

  handlePage(page: Page<AROrgeCampaign>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
  }

  addCampaignConfiguration(campaign: AROrgeCampaign) {
    this.router.navigate(['/orders', 'azote', 'orge', 'admin', 'new', campaign.id]);
  }

  deleteCampaignConfiguration(config: AROrgeCampaignConfiguration, event: any) {
    event.stopPropagation();
    // FIXME traiter les erreurs
    this.orgeService.deleteCampaignConfiguration(config).subscribe(
      (res) => {
        this.onChangeTable();
      },
      (error) => this.handleError(error, 'Impossible de supprimer la configuration'),
    );
  }

  handleError(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      console.error(error);
      showErrorMessage(this.modal, msg);
    }
  }

  editCampaignConfiguration(config: AROrgeCampaignConfiguration, event: any) {
    this.router.navigate(['/orders', 'azote', 'orge', 'admin', 'edit', config.id]);
  }

  ngOnInit() {
    this.onChangeTable();
  }

  ngAfterViewInit() {}

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    const pageNumber = page.page;
    this.getCampaignsPaginated(pageNumber, null, null, this.filter);
  }
}
